import { render, staticRenderFns } from "./CreateCategoryPropertyModal.vue?vue&type=template&id=5d05224e&scoped=true"
import script from "./CreateCategoryPropertyModal.vue?vue&type=script&lang=js"
export * from "./CreateCategoryPropertyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05224e",
  null
  
)

export default component.exports